import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Button from '../components/Button';
import CircleButton from '../components/CircleButton';
import CheeseDrip from '../assets/img/drip.svg';
import RecordingBtn from '../assets/img/recording-btn.png';

const TimerWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: -58px -16px 0;
  box-sizing: border-box;
`;
const TimesUp = styled.div`
  position: absolute;
  bottom: 60px;
  left: 0;
  width: 100%;
  padding: 0 16px 32px;
  box-sizing: border-box;

  > p {
    font-family: 'Speedee Bold';
    font-size: 32px;
    line-height: 0.95;
    letter-spacing: -0.15px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 16px;
  }

  .view-result-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      margin-right: 8px;
    }
  }
`;

const Curtain = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFBC0D;
  transform: scaleY(0);
  transform-origin: center top;

  img {
    position: absolute;
    top: 99%;
    width: 100vw;
  }
`;

const TimerText = styled.div`
  position: absolute;
  top: 0;
  left: calc(50vw - 154px);
  padding-top: calc(50vh - 96px);
  font-family: 'Speedee Bold';
  font-size: 127px;
  line-height: 95%;
  font-weight: bold;
  letter-spacing: -0.03em;
  color: #2D2D2D;
  text-align: left;
  box-sizing: border-box;
`;

const StyledFooterPanel = styled.div`
  position: absolute;
  display: flex;
  bottom: 0;
  left: 50%;
  width: 748px;
  height: 420px;
  background: none;
  justify-content: center;
  border-radius: 50%;
  transform: translate3d(-50%, 50%, 0);

  > * {
    transform: translateY(-50%);
  }

  img {
    width: 100%;
  }
`;

const HintText = styled.div`
  position: absolute;
  left: 18px;
  bottom: 264px;
  white-space: nowrap;
  font-family: 'Speedee Bold';
  font-size: 40px;
  line-height: 0.95;
  letter-spacing: -0.05em;
  color: #2D2D2D;

  > span {
    display: block;

    > span {
      display: inline-block;
      padding: 4px;
      white-space: nowrap;

      > span {
        position: relative;
        color: transparent;

        &:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 8px;
          width: 100%;
          height: 4px;
          background: #2D2D2D;
        }
      }
    }
  }

  > span:nth-child(1) > span {
    background: #E6A65D;
  }

  > span:nth-child(2) > span {
    background: #C96241;
  }

  > span:nth-child(3) > span {
    background: #A9C23F;
  }

  > span:nth-child(4) > span {
    background: #FFBC0D;
  }

  > span:nth-child(5) > span {
    background: #EDC8A3;
  }

  &.reveal-all {
    > span {
      > span {
        > span {
          color: #2D2D2D;

          &:after {
            display: none;
          }
        }
      }
    }
  }
`;

const ButtonText = styled.p`
  position: absolute;
  top: 40px;
  font-family: 'Speedee Bold';
  font-size: 20px;
  font-weight: bold;
  line-height: 0.95em;
  letter-spacing: -0.05em;
  margin: 26px 0 0 0;
`;

function TimerChant({ ...props }) {
  const [timerStarted, setTimerStarted] = useState(false);
  const [timerFinished, setTimerFinished] = useState(false);
  const [isProcessing, setIsProcessing] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const { score, attemptCount, setAttemptCount, setPage, page } = props;
  const [timer, setTimer] = useState(4);

  const handleResultClick = useCallback(() => {
    if (isSuccess || score >= 60) {
      setPage('success');
      window.gtag('event', `chant_${attemptCount < 2 ? 'success' : 'failure'}_voice_${attemptCount + 1}`);
    } else {
      setPage('try-again-chant');
      window.gtag('event', `chant_failure_voice_${attemptCount + 1}`);
    }
  }, [attemptCount, isSuccess, score, setPage]);

  useEffect(() => {    
    if (timer <= 0 && !isProcessing) {
      if (score >= 60) {
        window.gtag('event', `chant_success_voice_${attemptCount + 1}`);
        setIsSuccess(true);
        setPage('success');
      } else {
        window.gtag('event', `chant_failure_voice_${attemptCount + 1}`);

        if (attemptCount >= 2) {
          setPage('success');
        } else {
          setPage('try-again-chant');
        }
      }
    }

    const startTimer = () => {
      setTimer(4);

      const interval = setInterval(() => {
        setTimer(prev => {
          const newTime = prev - 0.01;
          if (newTime <= 0) {
            clearInterval(interval);
            setTimerFinished(true);
            
            if (page === 'timer-chant') {
              if (attemptCount >= 2) {
                setIsSuccess(true);
                setIsProcessing(false);
                setPage('success');
                window.gtag('event', `chant_failure_voice_${attemptCount + 1}`);
              } else {  
                setTimeout(function() {  
                  setIsProcessing(false);
                }, 2000);
              }
  
              return 0;
            }
          }
          return newTime;
        });
      }, 10);
    };

    if (!timerStarted) {
      setTimerStarted(true);
      setTimer(4);
      startTimer();
    }
  }, [timerStarted, setTimerStarted, timer, setTimer, attemptCount, setPage, score, setAttemptCount, handleResultClick, page, isProcessing]);

  return (
    <TimerWrapper>
      <Curtain style={{ transform: `scaleY(${1 - timer / 4})` }}><img src={CheeseDrip} alt="Cheese Drip"></img></Curtain>
      <TimerText style={{ color: timer <= 0 ? '#DB0007' : '#2D2D2D', paddingTop: attemptCount > 0 ? 'calc(50vh - 240px)' : 'calc(50vh - 90px)' }}>0{timer.toFixed(2)}</TimerText>
      {attemptCount > 0 && (
        <HintText className={ attemptCount === 2 && 'reveal-all' }><span><span>Two <span>all-beef patties</span>,</span></span><span><span>special sauce,</span></span><span><span><span>lettuce</span>, cheese,</span></span><span><span>pickles, <span>onions</span>,</span><span><span>on </span></span><span><span>a </span></span></span><span><span><span>sesame</span> seed bun.</span></span></HintText>
      )}
      {!timerFinished && (
        <StyledFooterPanel>
          <CircleButton>
            <img src={RecordingBtn} alt="Recording Button" className='recording-img'/>
          </CircleButton>
          <ButtonText>Recording...</ButtonText>
        </StyledFooterPanel>
       )} 
      {timerFinished && (
        <TimesUp>
          <p>Time's up!</p>
          <Button theme='simple' onClick={handleResultClick} disabled={isProcessing}>{ isProcessing ? 'Processing...' : 'View result' }</Button>
        </TimesUp>
      )}
    </TimerWrapper>
  );
}

export default TimerChant;